import React from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  RadioProps,
  Typography
} from '@material-ui/core';
import { useField, useFormikContext } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  multilineColor: {
    color:'#000',
    alignItems: 'right',
    fontFamily:"Segoe UI",
    textAlign:'right',
    padding:'16px',
    paddingRight:"3px",
    fontWeight:"600",
  },
}));

const RadioWrapper = ({
  name,
  options,
  label,
  legend,
  ...otherProps
}) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);
  const classes = useStyles();
  const handleChange = evt => {
    const { checked } = evt.target;
    setFieldValue(name, checked);
  };

  const configCheckbox = {
    ...field,
    onChange: handleChange
  };

  const configFormControl = {};
  if (meta && meta.touched && meta.error) {
    configFormControl.error = true;
    configFormControl.helperText = meta.error;
  }

  return (
    <FormControl {...configFormControl}>
    <div style={{display: 'flex', flexDirection: 'row'}}>
      <FormLabel component="legend" className= {classes.multilineColor} >
        {legend}
      </FormLabel>
      <RadioGroup aria-label="gender" name="gender1" row>
      {Object.keys(options).map((item, pos) => {
        return (
          <>
        <RadioButtonGroup 
          value={item}
          name={name}
          color="primary"
          label={item}/>
        </>
        )
      })}
      
      </RadioGroup>
      </div>     
       <Typography style={{color:"red"}}>{configFormControl.helperText}</Typography>
      
    </FormControl>
  );
};

export default RadioWrapper;

export function RadioButtonGroup(props) {
  const [field] = useField({
    name: props.name,
    type: "radio",
    value: props.value,
  });
  return (
    
    <FormControlLabel
      control={<Radio {...props} {...field} />}
      label={props.label}
    />
    
  );
}